import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppServiceService } from 'src/app/api/app-service.service';
import { StorageService } from '../../core/storage.service';
import { ModalController } from '@ionic/angular';
import { OTPVerificationPage } from '../modals/otp-verification/otp-verification.page';
import { TranslateService } from '@ngx-translate/core';
import { InputSelectModalComponent } from 'src/app/component/input-select-modal/input-select-modal.component';
import { InputSelectModalPointsComponent } from 'src/app/component/input-select-modal-points/input-select-modal-points.component';

import { Clipboard } from '@ionic-native/clipboard/ngx';

declare var config: any;

@Component({
  selector: 'app-profile-update',
  templateUrl: './profile-update.page.html',
  styleUrls: ['./profile-update.page.scss'],
})
export class ProfileUpdatePage implements OnInit {

  // otp verifgication template for web view
  @ViewChild('otpVerification') otpVerificationTemp: TemplateRef<any>;

  public passwordChange = false;
  public profile_details = {
    customer_id: '',
    first_name: '',
    last_name: '',
    email: '',
    mobile_number: '',
    newsalert: 'false',
    points: [],
    is_verified: false,
    referral_code: '',
    profile_image: null,
    company: null
  }

  public addressBook: any = [];

  public passwordDetails = {
    customer_id: '',
    password: '',
    confirm_password: ''
  }
  public newsalert: boolean = false;

  public isPasswordChangable: boolean = false;
  logOutInProgress: boolean = false;

  public isExpanDiv: boolean = false;
  public selectedResturentIndex: Number = null;
  public isDeleteAccount: boolean = false;
  public otp: any;
  public msgOtp: any = {
    "msg": "",
    "type": "",
  };
  public profileExpandAndError: any = {
    'name': { is_expand: false, errors: [] },
    'email': { is_expand: false, errors: [] },
    'mobile_number': { is_expand: false, errors: [] },
    'password': { is_expand: false, errors: [] },
    'address': { is_expand: false, errors: [] },
    'company': { is_expand: false, errors: [] }
  };

  // referral code copied status to display copied! message for few seconds
  public codeCopied: boolean = false;

  registerForm = new FormGroup({
    firstName: new FormControl(this.profile_details.first_name, {
      validators: [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(30),
      ],
      updateOn: 'change'
    }),
    lastName: new FormControl(this.profile_details.last_name, {
      validators: [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(30),
      ],
      updateOn: 'change'
    }),
    telephone: new FormControl(this.profile_details.mobile_number, {
      validators: [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(30),
        Validators.pattern(/(\(?([\d \-\)\–\+\/\(]+)\)?([ .\-–\/]?)([\d]+))/)
      ],
      updateOn: 'change'
    }),
    email: new FormControl(this.profile_details.email, {
      validators: [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"),
        // Validators.pattern("^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$"),
      ],
      updateOn: 'change'
    }),
  });

  passwordForm = new FormGroup({
    password: new FormControl(this.passwordDetails.password, {
      validators: [
        Validators.maxLength(30),
        // Validators.pattern("^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,}$")

      ],
      updateOn: 'change'
    }),
    confirm_password: new FormControl(this.passwordDetails.confirm_password, {
      validators: [
        Validators.maxLength(30),
        // Validators.pattern("^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,}$")

      ],
      updateOn: 'change'
    }),
  });

  isUpdateInProgress: boolean = false;

  emailAddressBackup: string = '';
  registrationType: string = '';

  public activePointsObject: any = null;

  public isFirstNameRequired: boolean = false;
  public isLastNameRequired: boolean = false;
  public isEmailRequired: boolean = false;
  public isMobileNumberRequired: boolean = false;
  public validationErrors: any;
  public lang: any = null;
  public restaurantList = [];
  // currently selected restaurant object
  public selectedRestaurant = null;
  public pointHistory = [];
  public totalPointCount = 0;

  // OTP Verification Page Verification response object for web version
  public otpCodeResponse: { sentVia: string, userData: any, operationType: string } | null = null;
  public selectedRestaurantPaymentMethods: any;

  public isReferralSystemEnabled: boolean = false;

  public selectedRestaurantRechargeIsEnabled = false;


  constructor(public appService: AppServiceService, public storage: StorageService, public modalController: ModalController, private modalCtrl: ModalController,
    public translate: TranslateService, private clipboard: Clipboard) {

  }

  ngOnInit() {
    if (this.appService.isWebVersion) {
      this.getCustomer();
      this.getLang();
    }
  }

  // ionViewWillEnter() {
  //   this.getCustomer();
  // }

  ionViewDidEnter() {
    this.getCustomer();
    this.getLang();
  }

  getRestaurantList() {
    this.appService.getPointsEnabledAllRestaurants().then((pointsEnabledRestaurantsList: any) => {
      if (pointsEnabledRestaurantsList.status) {
        this.restaurantList = pointsEnabledRestaurantsList.data;
        this.referralSystemStatus();
        if (this.restaurantList.length > 0) {
          this.selectedRestaurant = this.restaurantList[0];
          this.selectedRestaurantPaymentMethods = JSON.parse(this.selectedRestaurant?.payment_methods);

          this.activePointsObject = this.profile_details.points.find((pointData) => pointData.restaurant_id === this.selectedRestaurant.id);
          this.checkPointRechargeEnabled();
        } else this.appService.appObject.isLoading = false;
      }
    })
  }

  getCustomer() {
    setTimeout(() => {
      this.appService.appObject.isLoading = true;
    }, 10);

    this.profile_details.customer_id = this.appService.appObject.userId;
    this.passwordDetails.customer_id = this.appService.appObject.userId;
    this.getUserDetails();
  }

  getUserDetails() {

    this.appService.getUserDetails(this.profile_details).then((data: any) => {
      if (data.status) {
        this.profile_details.customer_id = data.data.id;
        this.profile_details.first_name = data.data.first_name;
        this.profile_details.last_name = data.data.last_name;
        this.profile_details.email = data.data.email;
        this.profile_details.mobile_number = data.data.mobile_number;
        this.profile_details.newsalert = data.data.is_newsalert;
        this.profile_details.is_verified = data.data.is_verified === 'true' ? true : false;
        this.profile_details.referral_code = data.data.referral_code;
        this.profile_details.company = data.data.company;
        this.registrationType = data.data.type;
        this.isPasswordChangable = this.registrationType === 'google' || this.registrationType === 'facebook' || this.registrationType === 'apple' ? false : true;
        this.emailAddressBackup = this.registrationType === 'google' || this.registrationType === 'facebook' || this.registrationType === 'apple' ? data.data.email : '';
        this.newsalert = data.data.is_newsalert === 'true' ? true : false;
        let pointsData = data.data.points ? data.data.points : [];

        this.profile_details.profile_image = data.data.profile_image;

        // if (Object.keys(pointsData).length > 0) {
        //   Object.keys(pointsData).forEach(key => {
        //     pointsData[key].id = parseInt(key);
        //   });
        this.profile_details.points = pointsData;
        //   if (this.appService.appObject.selectedRestaurantId != null) {
        //     this.selectedResturentIndex = this.profile_details.points.findIndex((data) => (data.id === this.appService.appObject.selectedRestaurantId));
        //     if (this.selectedResturentIndex != -1) this.moveItem(this.selectedResturentIndex, 0);
        //   }
        // }

        // get address book data
        this.addressBook = data.data.addressBook ? data.data.addressBook : [];

        this.getRestaurantList();
      }
      this.appService.appObject.isLoading = false;
      console.log("Pppp", this.appService.appObject.selectedRestaurantDetails);
    }, error => {
      this.appService.appObject.isLoading = false;
    });
  }

  public passwordMatchValidator(g: FormGroup) {
    return g.get('password').value === g.get('passwordConfirm').value
      ? null : { 'mismatch': true };
  }

  public isValidForm(form, input) {
    return (form.get(input).invalid && (form.get(input).dirty || form.get(input).touched));
  }

  async update() {
    this.registerForm.markAsTouched();
    this.registerForm.controls['firstName'].markAsTouched();
    this.registerForm.controls['lastName'].markAsTouched();
    this.registerForm.controls['telephone'].markAsTouched();
    this.registerForm.controls['email'].markAsTouched();


    if (this.registerForm.valid) {
      if (this.newsalert === true) {
        this.profile_details.newsalert = "true";
      } else {
        this.profile_details.newsalert = "false";
      }
      // replace email address to avoid if user change disabled email input 
      if (this.registrationType === 'google' || this.registrationType === 'facebook' || this.registrationType === 'apple') this.profile_details.email = this.emailAddressBackup;

      this.isUpdateInProgress = true;
      this.appService.updateProfile(this.profile_details).then(data => {
        if (data.status) {
          if (data.msg) this.appService.showToast(data.msg);
          this.getUserDetails();
        }
        this.isUpdateInProgress = false;
      }, error => {
        this.appService.appObject.isLoading = false;
        this.isUpdateInProgress = false;
      });
    }
  }

  async updatePassword() {
    this.isUpdateInProgress = true;
    this.appService.updatePassword(this.passwordDetails).then(data => {
      if (data.status) {
        if (data.msg) this.appService.showToast(data.msg);
        this.getUserDetails();
        this.profileExpandAndError.password.is_expand = false;
      }
      if (data.msg) {
        this.validationErrors = data.msg;
        this.appService.appObject.errors = this.appService.getErrorArray(data.msg);
        if (data.msg.password !== undefined || data.msg.confirm_password !== undefined) {
          this.profileExpandAndError.password.is_expand = true;
        }
      }
    });
    this.isUpdateInProgress = false;
  }

  emailvalidation() {
    if (this.registerForm.value.email) {
      this.registerForm.get('email').setValue(this.registerForm.value.email.trim());
    }
  }

  logout() {
    this.logOutInProgress = true;
    this.appService.logOut().then((resp) => this.logOutInProgress = false).catch((error) => this.logOutInProgress = false);
  }

  expanDiv() {
    this.isExpanDiv = !this.isExpanDiv;
  }

  moveItem(from, to) {
    var f = this.profile_details.points.splice(from, 1)[0];
    this.profile_details.points.splice(to, 0, f);
  }

  changePointObject(point) {
    if (point) {
      this.activePointsObject = point;
      // this.isExpanDiv = this.isExpanDiv ? false : this.isExpanDiv;
    }
  }

  account_delete_send() {
    this.msgOtp = {
      "msg": "",
      "type": "",
    };
    this.appService.appObject.isLoading = true;
    this.appService.sendAccountDeleteEmail({ "customer_id": this.profile_details.customer_id }).then(async data => {
      if (data.status) {
        this.isDeleteAccount = true;
        this.msgOtp.type = "s";
        this.msgOtp.msg = data.msg;

        this.appService.startVerificationCodeIntervalCountdown();

        let verificationPopUp = null;
        if (this.appService.isWebVersion) {

          this.otpCodeResponse = data;
          this.otpCodeResponse.userData = this.profile_details;
          this.otpCodeResponse.operationType = 'account_deletion';
          this.otpCodeResponse.sentVia = data.sendVia;

          // // this.onVerificationCodeSent.emit(verificationResponse);

          verificationPopUp = await this.modalController.create({
            component: InputSelectModalComponent,
            cssClass: 'select-modal',
            componentProps: {
              content: this.otpVerificationTemp,
              hideFooter: true
            },
          });
        } else {
          // open otp verification popup
          verificationPopUp = await this.modalController.create({
            component: OTPVerificationPage,
            cssClass: 'custom-popup',
            componentProps: {
              userData: this.profile_details,
              operationType: 'account_deletion',
              previousCodeSentVia: data.sendVia
            }
          });
        }

        await verificationPopUp.present();
        // on dismiss check returned data 
        verificationPopUp.onDidDismiss().then((response: any) => {
          // console.log(response);
          if (response.data && response.data.isVerified) {
            // console.log('account delete called');
            this.otp = response.data.extra.otp_code;
            this.account_delete();
          }

          this.isDeleteAccount = false;
        });
      } else {
        this.msgOtp.type = "e";
        this.msgOtp.msg = data.msg;
      }
      this.appService.appObject.isLoading = false;

    }, error => {
      this.appService.appObject.isLoading = false;
    });
  }

  account_delete() {
    this.msgOtp = {
      "msg": "",
      "type": "",
    };
    this.appService.appObject.isLoading = true;
    this.appService.sendAccountDelete({ "customer_id": this.profile_details.customer_id, "otp": this.otp }).then(data => {
      if (data.status) {
        this.isDeleteAccount = false;
        this.msgOtp.type = "s";
        this.msgOtp.msg = data.msg;
        this.logout();
        if (this.appService.isWebVersion) {
          this.appService.modalDismiss();
        }
      } else {
        this.msgOtp.type = "e";
        this.msgOtp.msg = data.msg;
      }
      this.otp = "";
      this.appService.appObject.isLoading = false;
    }, error => {
      this.isDeleteAccount = false;
      this.appService.appObject.isLoading = false;
    });
  }

  /**
   * Delete address from address book
   * @param address address object
   */
  onAddressDelete(address) {
    address.deleteInProgress = true;
    this.appService.removeUserAddress(address.id).then((response) => {
      // console.log(response);
      if (response.status) {
        address.deleteInProgress = false;
        this.getUserDetails();
        this.appService.showToast(response.msg, 'success', 'bottom', 3000);
      } else {
        address.deleteInProgress = false;
        this.appService.showToast(response.msg, 'danger', 'bottom', 3000);
      }
    }).catch((error) => {
      console.log(error);
      address.deleteInProgress = false;
      this.appService.showToast('Something went wrong', 'danger', 3000);
    });
  }

  async updateNew() {
    if (this.newsalert === true) {
      this.profile_details.newsalert = "true";
    } else {
      this.profile_details.newsalert = "false";
    }
    // replace email address to avoid if user change disabled email input 
    if (this.registrationType === 'google' || this.registrationType === 'facebook' || this.registrationType === 'apple') this.profile_details.email = this.emailAddressBackup;

    this.isUpdateInProgress = true;
    this.appService.updateProfile(this.profile_details).then(data => {
      if (data.status) {
        if (data.msg) this.appService.showToast(data.msg);
        this.getUserDetails();
        this.profileExpandAndError.name.is_expand = false;
        this.profileExpandAndError.email.is_expand = false;
        this.profileExpandAndError.mobile_number.is_expand = false;
        this.profileExpandAndError.company.is_expand = false;
      }

      if (data.msg) {
        this.validationErrors = data.msg;
        if (data.msg.first_name !== undefined || data.msg.last_name !== undefined) {
          this.profileExpandAndError.name.is_expand = true;
        }
        if (data.msg.email !== undefined) {
          this.profileExpandAndError.email.is_expand = true;
        }
        if (data.msg.mobile_number !== undefined) {
          this.profileExpandAndError.mobile_number.is_expand = true;
        }
      }

      this.isUpdateInProgress = false;
    }, error => {
      this.isUpdateInProgress = false;
    });
  }

  verifyCustomer() {
    if (this.appService.appObject.userVerificationRequired) {
      this.appService.appObject.isLoading = true;
      let verificatioData = { mobile_number: this.profile_details.mobile_number, email: this.profile_details.email };
      // request verification code, will check in backend for the method mobile / email and send back the method
      this.appService.requestVerificationCode(verificatioData).then(async (verificationResponse) => {
        // if verification code has been sent, will return the what method used to sent 
        if (verificationResponse.status) {
          this.appService.startVerificationCodeIntervalCountdown();

          // open otp verification popup
          const cartModal = await this.modalController.create({
            component: OTPVerificationPage,
            cssClass: 'custom-popup',
            componentProps: {
              userData: this.profile_details,
              operationType: 'profile-verification',
              previousCodeSentVia: verificationResponse.sentVia
            }
          });
          await cartModal.present();
          this.appService.appObject.isLoading = false;
          // on dismiss check returned data 
          cartModal.onDidDismiss().then((response: any) => {
            if (response.data && response.data.isVerified) {
              this.profile_details.is_verified = true;
            } else {
              this.appService.showToast(this.lang.msg);
            }
          });
        }
      })
    }
  }

  /**
   * 
   * get languages
   */
  async getLang() {
    await this.translate.get('key').subscribe(
      value => {
        this.lang = value;
      }
    )
  }

  clearError() {
    console.log("Hello");
  }

  inpuGroupToggle(e) {
    if (e !== '') {
      if (e === 'name') {
        this.profileExpandAndError.name.is_expand = !this.profileExpandAndError?.name?.is_expand;
      }
      if (e === 'email') {
        this.profileExpandAndError.email.is_expand = !this.profileExpandAndError?.email?.is_expand;
      }
      if (e === 'mobile_number') {
        this.profileExpandAndError.mobile_number.is_expand = !this.profileExpandAndError?.mobile_number?.is_expand;
      }
      if (e === 'password') {
        this.profileExpandAndError.password.is_expand = !this.profileExpandAndError?.password?.is_expand;
      }
      if (e === 'address') {
        this.profileExpandAndError.address.is_expand = !this.profileExpandAndError?.address?.is_expand;
      }
      if (e === 'company') {
        this.profileExpandAndError.company.is_expand = !this.profileExpandAndError?.company?.is_expand;
      }
    }
  }

  /**
   * Copy customer referral code to clipboard
   */
  copyReferralCode() {

    if (this.profile_details.referral_code && this.profile_details.referral_code.trim()) {
      let referralCode = this.profile_details.referral_code.trim();
      if (config.plf == 'web') {
        navigator.clipboard.writeText(referralCode)
          .then(() => {
            this.codeCopied = true;
            setTimeout(() => {
              this.codeCopied = false;
            }, 3000);
          })
          .catch((err) => {
            console.error('Unable to copy to clipboard', err);
            this.appService.showToast('Unable to copy to clipboard', 'danger');
          });
      }else{
        this.clipboard.copy(referralCode).then(
          () => {
            this.codeCopied = true;
            setTimeout(() => {
              this.codeCopied = false;
            }, 3000);  
          },
          (err) => console.error('Error copying to clipboard:', err)
        );
      }
    }
  }
  // /**
  //  * Fetch points history data of the user in selected restaurant
  //  */
  // getPointHistory() {
  //   this.appService.appObject.isLoading = true;
  //   this.appService.getPointHistory(this.selectedRestaurant.id).then((response: any) => {
  //     if (response.status) {
  //       this.pointHistory = response.data;
  //       this.totalPointCount = response.total_points;
  //     }
  //   }).catch((error) => {
  //     console.log('error : ', error);
  //   }).finally(() => {
  //     this.appService.appObject.isLoading = false;
  //   });
  // }

  async openModal(content: TemplateRef<any>) {
    const modal = await this.modalController.create({
      component: InputSelectModalComponent,
      cssClass: 'select-modal',
      componentProps: {
        content: content, // Pass the content as a TemplateRef
      },
    });
    // hide cart button when popup opening
    this.appService.hideCartButton = true;

    modal.present();

  }

  /**
   * Will trigger when user switch restaurants from the list
   * @param restaurant selected restaurant object
   */
  selectRestaurant(restaurant) {
    this.selectedRestaurant = restaurant;
    this.activePointsObject = this.profile_details.points.find((pointData) => pointData.restaurant_id === restaurant.id);
    this.checkPointRechargeEnabled();
  }

  /**
   * Will continuesly check referral system is enabled on at least single restaurant
   * @returns true / false
   */
  referralSystemStatus() {
    // check for referral system enabled restaurants
    // if at least one restaurnt has referral system enabled, then enable referral code
    let referralSystemEnabledRestaurant = this.restaurantList.find((restaurant) => {
      let methods = restaurant.payment_methods ? JSON.parse(restaurant.payment_methods) : [];
      if (methods.length) {
        let pointsCof = methods.find((method) => method.id === "points");
        if (pointsCof && pointsCof.pointsConfigurations) {
          return pointsCof.pointsConfigurations.referral_system_enabled === 'true' || pointsCof.pointsConfigurations.referral_system_enabled === true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    })

    if (referralSystemEnabledRestaurant) {
      this.isReferralSystemEnabled = true;
    } else {
      this.isReferralSystemEnabled = false;
    }
  }

  onProfilePictureClick() {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
  
    // Validate that the file is an image
    if (file && file.type.match('image.*')) {
      // Convert image to base64 for preview (if needed)
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.isUpdateInProgress = true; // Start update process
        this.profile_details.profile_image = e.target.result; // Store the image data URL for preview
        this.submitToUpdate();
      };
      reader.readAsDataURL(file);
  
  
      // Call the service to send image and profile details to the server
      
    }
  }

  submitToUpdate(){ 
    this.appService.updateProfilePicture(this.profile_details).then(
      (data: any) => {
        if (data.status) {
          if (data.msg) this.appService.showToast(data.msg);
          this.getUserDetails(); // Refresh user details on successful update
        }
        this.isUpdateInProgress = false;
      },
      (error: any) => {
        this.appService.showToast('Error uploading profile picture. Please try again.');
        this.isUpdateInProgress = false;
      }
    );
  }

    /**
   * Open payments modal popup
   */
    async openPaymentModal() {
      const modal = await this.modalCtrl.create({
        component: InputSelectModalPointsComponent,
        cssClass: 'select-modal',
        componentProps: {
          selectedRestaurant: this.selectedRestaurant
        },
      });
      // hide cart button when popup opening
      this.appService.hideCartButton = true;
  
      modal.present();
      // console.log(modal);
      modal.onWillDismiss().then(async (event) => {
        if(config.plf == 'app'){
            if(event.data.transaction_status === 'success'){
              await this.getCustomer();
            }
        }
      });
    }

      /**
   * Check whether selected restaurant has points recharge enabled or not
   */
  checkPointRechargeEnabled() {
    let methods = JSON.parse(this.selectedRestaurant.payment_methods);
    for (let index = 0; index < methods.length; index++) {
      const method = methods[index];
      if (method.id == 'points' && method?.pointsConfigurations?.points_recharge_enabled == 'true') {
        this.selectedRestaurantRechargeIsEnabled = true;
      }
    }
  }

}